import { Navigate, useLocation } from 'react-router-dom';
import { useEasyCheck } from '../../../context/EasyCheckContext';
import { usePermissions } from '../../../hooks/usePermissions';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useEasyCheck();
  const { loading: permissionsLoading, canAccess } = usePermissions();
  const location = useLocation();

  if (loading || (requiredPermission && permissionsLoading)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Per-user module permission (dashboard is always allowed, so / is a safe target)
  if (requiredPermission && !canAccess(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string
};

export default ProtectedRoute; 